(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', '../_util/vantEvent'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('../_util/vantEvent'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.vantEvent);
    global.vantBindEvent = mod.exports;
  }
})(this, function (exports, _vantEvent) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.BindEventMixin = BindEventMixin;


  var uid = 0; /**
                * Bind event when mounted or activated
                */
  function BindEventMixin(handler) {
    var key = 'binded_' + uid++;

    function bind() {
      if (!this[key]) {
        handler.call(this, _vantEvent.on, true);
        this[key] = true;
      }
    }

    function unbind() {
      if (this[key]) {
        handler.call(this, _vantEvent.off, false);
        this[key] = false;
      }
    }

    return {
      mounted: bind,
      activated: bind,
      deactivated: unbind,
      beforeDestroy: unbind
    };
  }
});